var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('svg-alert',{staticClass:"question-icon"}),_c('fta-textbox',[_c('p',[_vm._v("Debes seguir los pasos en orden para cumplir la misión. Revisa tu inventario.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }